import { render, staticRenderFns } from "./CommonSection.vue?vue&type=template&id=96cbcfe0&scoped=true"
import script from "./CommonSection.vue?vue&type=script&lang=ts"
export * from "./CommonSection.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=96cbcfe0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96cbcfe0",
  null
  
)

export default component.exports